import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  Container,
  Dropdown,
  Menu,
} from 'semantic-ui-react';
import { replace, push } from 'react-router-redux';
import config from '../../../../config';
import ProjectUnitsList from '../../../components/ProjectUnitsList';
import NavBar from '../../../components/NavBar';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { routes } from '../navigations';
import { showsProjectUnitsTab } from '../../../utils/vietnam';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    project: PropTypes.shape({
      projectPictures: PropTypes.array,
      gps: PropTypes.string,
      maOwnerCompanyBranchID: PropTypes.number,
    }),
    loading: PropTypes.bool,
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.object,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        himsIsEnabled: PropTypes.bool,
      }),
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  constructor(props) {
    super(props);
    const menuIsTab = window.innerWidth <= 590;
    this.state = {
      menuIsTab,
    };
  }
  componentDidMount() {
    this.redirectAgency(this.props);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    this.redirectAgency(nextProps);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  redirectAgency = (props) => {
    if (!showsProjectUnitsTab(props.auth)) {
      this.context.store.dispatch(replace(`/projects/${props.id}/`));
    }
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    if (this.props.auth.isBranchLeaderSupervisorII && this.props.project &&
      (this.props.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('bookApiURL')) || value.includes(config.get('salesChartURL'))) {
      e.preventDefault();
      const winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleUnitClick = (e, { unit }) => {
    const { store } = this.context;
    store.dispatch(push(`/projects/${this.props.id}/units/${unit.id}/`));
  }
  handleManageClick = (e, data) => {
    e.preventDefault();
    const { store } = this.context;
    if (data.value.includes(config.get('developerURL'))) {
      window.location.href = data.value;
    } else {
      store.dispatch(push(`/projects/${this.props.id}/units/${data.value}`));
    }
  }
  hasProjectHimsEnabled = () => {
    const { appConfig, project } = this.props;
    const companyHimsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    return companyHimsIsEnabled && project && project.himsIsEnabled;
  }
  render() {
    // Do not mount the unit list (or start its requests) while redirecting a VN agency.
    if (!showsProjectUnitsTab(this.props.auth)) return null;
    const { pathname } = this.props.location;
    const { project, auth, t } = this.props;
    const serviceCompanyID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const links = routes(this.props.id, project, this.hasAccess(), this.props.auth.isSiteplan, this.props.auth).map(l => ({
      ...l,
      text: t(l.text),
    }));
    return (
      <Container>
        <NavBar
          rightNav={this.hasAccess() ?
            <Dropdown item text={t('Manage')}>
              <Dropdown.Menu>
                <Dropdown.Item onClick={this.handleManageClick} value="create/">{t('Create', { ns: TRANSLATION_FILES.translation })}</Dropdown.Item>
                {this.hasAccess() && <Dropdown.Item onClick={this.handleManageClick} value="import/">{t('Import Units')}</Dropdown.Item>}
                {this.hasAccess() && <Dropdown.Item onClick={this.handleManageClick} value={config.get('developerURL') && serviceCompanyID ? `${config.get('developerURL')}/c/${serviceCompanyID}/projects/${this.props.id}/import/package_pricings` : 'import_pricings/'}>{t('Import Pricing Packages')}</Dropdown.Item>}
                {this.hasAccess() && this.hasProjectHimsEnabled() && <Dropdown.Item onClick={this.handleManageClick} value="hims/">{t('HIMS Unit Sync')}</Dropdown.Item>}
                {!this.state.menuIsTab && <Dropdown.Item onClick={this.handleManageClick} value="edit/">{t('Edit', { ns: TRANSLATION_FILES.translation })}</Dropdown.Item>}
              </Dropdown.Menu>
            </Dropdown> : null
          }
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                content={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
        />
        <ProjectUnitsList
          toggleable
          loading={this.props.loading}
          projectID={this.props.id}
          project={project}
          unitOnClick={this.handleUnitClick}
          hideNew={!this.hasAccess()}
          addPath={`/projects/${this.props.id}/units/create/`}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(List.mapStateToProps)(List));



// WEBPACK FOOTER //
// ./src/containers/Project/Units/List.jsx